import { IEntity, IMasterData, IMasterRole, IMasterScope, IMdhRequest, IMdhUserRole } from "@/models";

interface IMdhState {
    masterDatas: IMasterData[];
    masterScopes: IMasterScope[];
    myRequests: IMdhRequest[];
    pendingRequests: IMdhRequest[];
    roles: IMasterRole[];
    secretKeys: IEntity[];
    userRoles: IMdhUserRole[];
    validatedRequests: IMdhRequest[];
}

const initialState: IMdhState = {
    masterDatas: [],
    masterScopes: [],
    myRequests: [],
    pendingRequests: [],
    roles: [],
    secretKeys: [],
    userRoles: [],
    validatedRequests: [],
};

export { IMdhState, initialState };
